import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { DateTime } from '@totalsoft/rocket-ui';
import { getDateFormat } from 'utils/functions';

function PartnerFileBulkFilters({ filters, onFilterChange, saving }) {
  const { t } = useTranslation();

  return (
    <Grid container gap={2}>
      <Grid item xs={12} sm>
        <DateTime
          id={'partnerFileBulkList_filters_startDate'}
          label={t('BulkPartners.StartDate')}
          value={filters.startDate.value}
          onChange={onFilterChange('startDate')}
          format={getDateFormat()}
          error={!filters.startDate.isValid}
          helperText={!filters.startDate.isValid && t('Validations.Generic.InvalidDateFormat')}
          disabled={saving}
          isClearable
        />
      </Grid>
      <Grid item xs={12} sm>
        <DateTime
          id={'partnerFileBulkList_filters_endDate'}
          label={t('BulkPartners.EndDate')}
          value={filters.endDate.value}
          onChange={onFilterChange('endDate')}
          format={getDateFormat()}
          error={!filters.endDate.isValid}
          helperText={!filters.endDate.isValid && t('Validations.Generic.InvalidDateFormat')}
          disabled={saving}
          isClearable
        />
      </Grid>
    </Grid>
  );
}

PartnerFileBulkFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default PartnerFileBulkFilters;
